/**
 * Footer Component
 */

import React from 'react';
import { Heart, Mail, MessageCircle } from 'lucide-react';

const SUPPORT_EMAIL = 'support@khaltihaila.com';

export default function Footer({ navigate }) {
  const handleNavClick = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-3xl">👩‍🦳</span>
              <span className="text-2xl font-bold">خالتي هيلة</span>
              <Heart className="w-5 h-5 text-rose-500 fill-rose-500" />
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              من زمان وخالتي هيلة تعرف كيف توفّق بين الناس... 
              اليوم صارت أذكى بالذكاء الاصطناعي وتساعدك تلاقي نصيبك بالحلال
            </p>
            <div className="flex items-center gap-2 text-rose-400">
              <Heart className="w-4 h-4 fill-current" />
              <span className="text-sm">نربط راسين بالحلال</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">روابط سريعة</h3>
            <ul className="space-y-3">
              {[
                { path: '/', label: 'الرئيسية' },
                { path: '/features', label: 'المميزات' },
                { path: '/how-it-works', label: 'كيف يعمل؟' },
                { path: '/faq', label: 'الأسئلة الشائعة' },
              ].map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => handleNavClick(link.path)}
                    className="text-gray-400 hover:text-rose-400 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">قانوني</h3>
            <ul className="space-y-3 mb-6">
              {[
                { path: '/terms', label: 'الشروط والأحكام' },
                { path: '/privacy', label: 'سياسة الخصوصية' },
                { path: '/contact', label: 'تواصل معنا' },
              ].map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => handleNavClick(link.path)}
                    className="text-gray-400 hover:text-rose-400 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
            
            <h3 className="text-lg font-bold mb-3">تواصل معنا</h3>
            <a 
              href={`mailto:${SUPPORT_EMAIL}`}
              className="flex items-center gap-2 text-gray-400 hover:text-rose-400 transition-colors"
            >
              <Mail className="w-4 h-4" />
              <span className="text-sm">{SUPPORT_EMAIL}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm text-center md:text-right">
              © 2025 خالتي هيلة - جميع الحقوق محفوظة
            </p>
            <p className="text-gray-500 text-sm flex items-center gap-1">
              صُنع بـ <Heart className="w-3 h-3 text-rose-500 fill-rose-500" /> في السعودية 🇸🇦
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
